import { Injectable, NgModule } from "@angular/core";
import { BfxBlotterActionSubject } from "../bfx-base-blotter/bfx-base-blotter-contextmenu.service";

@Injectable({ providedIn: "root" })
export class BfxBlotterOrdersActionSubject extends BfxBlotterActionSubject {
  //
}

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [BfxBlotterOrdersActionSubject],
  bootstrap: [],
})
export class BfxBlotterOrdersActionSubjectModule {}
